<m-message-page class="m-error-technical-difficulty"
                  :state="state"
                  :svg-name="svgName"
                  :title="title"
                  :hints="hints"
                  :links="links">
    <m-accordion skin="light"
                 icon-size="small"
                 :open="openAccordion">
        <span slot="header">
            {{ $i18n.translate('m-error-technical-difficulty:details') }}
        </span>
        <p class="m-error-technical-difficulty__browser"><strong>{{ $i18n.translate('m-error-technical-difficulty:browser') }}: </strong>{{ userAgent }}</p>
        <p v-if="!!errorReferenceNumber"><strong>{{ $i18n.translate('m-error-technical-difficulty:reference-number') }}: </strong>{{ errorReferenceNumber }}</p>
        <p v-if="!!system"><strong>{{ $i18n.translate('m-error-technical-difficulty:system') }}: </strong>{{ system }}</p>
        <p>
            {{ $i18n.translate('m-error-technical-difficulty:date.primary') }}
            <strong>{{formattedDate}}</strong>
            {{ $i18n.translate('m-error-technical-difficulty:date.secondary') }}
            <strong>{{ formattedTime }}</strong>
        </p>
        <pre v-if="propStacktrace"
            ref="stacktrace"
            class="m-error-technical-difficulty__stacktrace">{{ error.stack }}</pre>
    </m-accordion>
</m-message-page>
